import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/getUnidades.php';

export default function getUnidades({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}